import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useTranslation } from "react-i18next";
import Header from "../../layout/Header/Header";
import MenuBotones from "../../MenuBotones";

function BotonesGastos() {
  const { user } = useContext(AuthContext);
  const [t] = useTranslation("global");

  if (!user.menu_gastos) return <Header />;

  const esAdmin = user.tipo == "Admin";

  return (
    <MenuBotones
      titulo={t("Costo Importacion")}
      descripcion={t("Gastos por contenedor y cuentas por pagar a brokers")}
      icono="fas fa-coins"
      color="#ea580c"
      secciones={[
        {
          section: t("Gastos"),
          items: [
            { label: t("Costo Importacion"), icon: "fas fa-receipt", color: "#ea580c", href: "/Gastos",
              desc: t("Gastos de cada contenedor"), enabled: !!user.menu_gastos },
            { label: t("Conceptos"), icon: "fas fa-list-ul", color: "#475569", href: "/ConceptosGastos",
              desc: t("Catálogo de conceptos de gasto"), enabled: !!user.menu_gastos && esAdmin },
          ],
        },
        {
          section: t("Cuentas por pagar"),
          items: [
            { label: t("Pagos"), icon: "fas fa-money-check-alt", color: "#16a34a", href: "/ListadoAbonosGastos",
              desc: t("Pagos a brokers"), enabled: !!user.menuPagos && esAdmin },
            { label: t("Estado de Cuenta"), icon: "fas fa-file-invoice-dollar", color: "#2563eb", href: "/EstadoCuentaCXP",
              desc: t("Saldo por broker"), enabled: !!user.estadoCuentaBrokers && esAdmin },
          ],
        },
      ]}
    />
  );
}

export default BotonesGastos;
